'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  angular.module('ibf').controller('loginAsModalCtrl', ['$scope', 'alertify', 'commonSrv', 'adminSrv', 'growerSrv', '$uibModalInstance', 'config', 'environment', 'sessionSrv', '$state', loginAsModalCtrl]).controller('countryNavCtrl', ['$scope', 'alertify', '$state', 'commonSrv', 'sessionSrv', '$uibModal', 'environment', countryNavCtrl]).controller('growerInfoModalCtrl', ['$scope', 'commonSrv', '$uibModalInstance', '$filter', 'floristSrv', 'environment', growerInfoModalCtrl]);

  function countryNavCtrl($scope, alertify, $state, commonSrv, sessionSrv, $uibModal, environment) {
    var nav = this,
        common = commonSrv,
        session = sessionSrv;
    nav.growers = [];
    nav.showClaims = false;
    nav.goToV2 = false;
    nav.showProducts = true;
    nav.isBookKeeping = false;
    nav.isLogisticsSupport = false;
    nav.isSupport = false;
    nav.adminProducts = environment.v2Url + '#/products/variety';
    nav.showAdminGrowers = false;
    nav.openStandingOrderPriceStatus = function () {
      $state.go('country.standing_order_price_status');
    };
    nav.include = function (name) {
      return $state.includes('country.' + name);
    };

    nav.isCurrent = function (name) {
      return $state.is('country.' + name);
    };

    function init() {
      nav.name = common.getUserData().data.name;
      if (common.getUserData().ibf_role === "COUNTRY_MANAGER") {
        nav.showLoginAs = true;
        nav.showGrowerInfo = true;
        nav.showFarmDashboardRoute = true;
        nav.showStandingOrderPriceStatus = true;
      }

      // console.log('common.getUserData()', common.getUserData())
      if (common.getUserData().ibf_role === "SUPPORT") {
        nav.isSupport = true;
        nav.adminProducts = environment.v2Url + '#/settings/create_voucher';
      }

      if (["LOGISTICS_SUPPORT", "SUPPORT", "ADMIN"].includes(common.getUserData().ibf_role)) {
        nav.showFarmDashboardRoute = true;
      }

      var supportUsers = common.getConfig().admin_support_users;

      if (supportUsers && supportUsers.length > 0 && supportUsers.includes(common.getUserData().key)) {
        nav.showAdminGrowers = true;
      }

      if (common.getUserData().ibf_role === "BOOKKEEPING") {
        nav.isBookKeeping = true;
        nav.showLoginAs = true;
        nav.showGrowerInfo = true;
        nav.showStandingOrderPriceStatus = true;
      }

      if (common.config.availableUsersToV2 && common.config.availableUsersToV2.includes(common.getUserData().key)) {
        nav.goToV2 = true;
      }

      nav.showClaims = common.getUserData().ibf_role === 'SUPPORT' && !nav.isBookKeeping;
      nav.showProducts = common.getUserData().ibf_role !== 'SUPPORT' && !nav.isBookKeeping;

      if (common.getUserData().ibf_role === "LOGISTICS_SUPPORT") {
        nav.showLoginAs = true;
        nav.showGrowerInfo = true;
        nav.isLogisticsSupport = true;
        nav.showProducts = false;
        nav.showStandingOrderPriceStatus = true;
      }

      nav.validateSession();
    }

    nav.validateSession = function () {
      if (sessionSrv.getToken()) {
        nav.user = common.getUserData().data;
        common.setHeaders(common.getUserData().token);
      }
    };

    nav.openLoginAsModal = function () {

      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/login-as-modal.html',
        controller: 'loginAsModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              growers: nav.growers
            };
          }
        }
      });
      modalInstance.result.then();
    };

    nav.openGrowerModal = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/country/growers-modal.html',
        controller: 'loginAsModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          config: function config() {
            return {
              growers: nav.growers,
              openModalGrowerByMasterList: true
            };
          }
        }
      });
      modalInstance.result.then();
    };

    nav.redirectFarmDashboard = function () {
      window.open(common.config.looker_grower_dashboard_link);
    };

    nav.openGrowerInfoModal = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/admin/growerInfoModal.html',
        controller: 'growerInfoModalCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          config: function config() {
            return {
              growers: nav.growers
            };
          }
        }
      });
      modalInstance.result.then();
    };

    nav.logout = function () {
      session.logout();
    };

    init();
  }
})(angular);

function loadCountryVisibleGrowers(commonSrv, environment) {
  var userData = commonSrv.getUserData() || {};
  var countries = userData.countries ? userData.countries.map(function (item) {
    return item.country;
  }) : [];
  var showAll = ['BOOKKEEPING', 'LOGISTICS_SUPPORT', 'ADMIN'].includes(userData.ibf_role);

  return commonSrv.method.run({
    key: environment.cloudscript.loadDependencies,
    params: {
      includes: ['grower']
    }
  }).then(function (res) {
    var growers = [];

    if (res && res.success && res.results && res.results.grower) {
      growers = showAll ? res.results.grower.filter(function (item) {
        return item.active;
      }) : countries.length > 0 ? res.results.grower.filter(function (item) {
        return item.active && countries.includes(item.country);
      }) : [];
    }

    return growers.sort(function (a, b) {
      return a.company_name.localeCompare(b.company_name);
    });
  });
}

function loginAsModalCtrl($scope, alertify, commonSrv, adminSrv, growerSrv, $uibModalInstance, config, environment, sessionSrv, $state) {
  var modal = this,
      common = commonSrv;
  modal.growers = [];
  modal.loading = false;
  modal.isBookKeeping = false;
  modal.masterlistByGrower = {};
  modal.growersMap = {};

  function init() {
    modal.loading = true;
    modal.loadingGrowers = true;
    modal.listGrower = [];
    if (common.getUserData().ibf_role === "BOOKKEEPING") {
      modal.isBookKeeping = true;
    }
    loadCountryVisibleGrowers(commonSrv, environment).then(function (growers) {
      modal.growers = growers;
      modal.loading = false;
      modal.listGrower = modal.growers;
      modal.loadingGrowers = true;

      if (config.openModalGrowerByMasterList) {
        modal.loadingGrowers = true;

        modal.growers.forEach(function (grower) {
          modal.growersMap[grower._KEY] = grower;
        });

        modal.getMasterListByGrower(modal.growersMap, function (data) {
          var masterlist = data.results.reduce(function (obj, item) {
            if (!(item.grower in obj)) {
              obj[item.grower] = [item];
            } else {
              obj[item.grower].push(item);
            }

            return obj;
          }, {});

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            var _loop = function _loop() {
              var _step$value = _slicedToArray(_step.value, 2),
                  keyGrower = _step$value[0],
                  arrayMasterList = _step$value[1];

              modal.listGrower.forEach(function (grower) {
                if (grower._KEY === keyGrower) {
                  grower.growerMasterList = arrayMasterList;
                  grower.activeMasterList = arrayMasterList.every(function (item) {
                    return item.active;
                  });
                }
              });
            };

            for (var _iterator = Object.entries(masterlist)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              _loop();
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          modal.loadingGrowers = false;
        }, function (error) {
          alertify.error('Failed to load masterlist by grower');
          modal.loadingGrowers = false;
        });
      } else {
        modal.loadingGrowers = false;
      }
    }).catch(function () {
      modal.loading = false;
      modal.loadingGrowers = false;
      alertify.error('Failed to load growers');
    });
  }

  modal.getMasterListByGrower = function (growersMap, onSuccess, onError) {
    var query = commonSrv.sbx.with('add_masterlist').andWhereIn('grower', Object.keys(growersMap)).compile();
    commonSrv.loadAllPages(query, function (data) {

      if (data.results.length) {
        onSuccess(data);
      } else {
        onError('error');
      }
    });
  };

  modal.getGrowers = function () {

    var countries = [];

    if (common.getUserData().countries) {
      countries = common.getUserData().countries.map(function (it) {
        return it.country;
      });
    }

    common.listGrowers(countries, function (data) {

      modal.growersAll = data.sort(function (a, b) {
        return a.company_name.localeCompare(b.company_name);
      });

      //

      /*** */
      modal.growersAll.forEach(function (grower) {
        modal.growersMap[grower._KEY] = grower;
      });

      modal.getMasterListByGrower(modal.growersMap, function (data) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {

          for (var _iterator2 = modal.growersAll[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var grower = _step2.value;

            Object.keys(data.fetched_results.grower).map(function (key) {

              return modal.masterlistByGrower[key] = data.results.filter(function (item) {
                return item.grower === key;
              });
            });
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = Object.keys(modal.masterlistByGrower)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _keyGrower = _step3.value;

                if (grower._KEY == _keyGrower) {
                  grower.growerMasterList = modal.masterlistByGrower[_keyGrower];

                  grower.activeMasterList = modal.masterlistByGrower[_keyGrower].every(function (item) {
                    return item.active;
                  });
                }
                modal.loadingGrowers = false;
                modal.listGrower = modal.growersAll;

                //modal.listGrower= modal.growersAll.filter(item=>item.growerMasterList)

              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }, function (error) {
        alertify.error('Failed to load masterlist by grower');
        modal.loadingGrowers = false;
      });
    }, function (error) {
      alertify.error(error);
    });
  };

  modal.toggleActiveMasterList = function (grower, status, key) {

    if (grower.length === 0) return;

    var items = grower.map(function (item) {
      var container = {};
      container['_KEY'] = item._KEY;
      container['activeMasterList'] = status;
      return container;
    });

    common.confirmModal({
      title: '',
      msj: 'Are you sure want to  ' + (status ? 'activate' : 'inactivate') + '?',
      saveText: 'Yes',
      cancelText: 'No, go back'

    }, function () {
      modal.loadingGrowers = true;
      common.method.run({
        key: environment.cloudscript.ibf_updateMasterListByGrower,
        params: { items: items }
      }).then(function (response) {

        modal.loadingGrowers = false;
        if (response.success) {
          modal.listGrower.forEach(function (item) {
            if (item._KEY === key) {

              item.activeMasterList = status;
            }
          });
          alertify.success('All grower master lists were updated');

          var auditObj = {
            action: 'UPDATE_ALL_MASTERLIST',
            user: common.getUserData().key,
            date: new Date(),
            description: 'The following masterlist were updated by ' + common.getUserData().data.name,
            object_string: JSON.stringify(items.map(function (item) {
              return item._KEY;
            }))
          };
          common.createAudit(auditObj, function (res) {}, function (err) {});
        } else {
          alertify.error('Failed to update the masterlist');
          modal.listGrower.forEach(function (item) {
            if (item._KEY === key) {

              item.activeMasterList = !status;
            }
          });
        }
      }).catch(function (err) {
        alertify.error('An error has occurred on the server');
      });
    }, function (err) {

      modal.listGrower.forEach(function (item) {
        if (item._KEY === key) {

          item.activeMasterList = !status;
        }
      });
    });
  };
  modal.toggleActiveGrower = function (key, status) {

    var active = status ? false : true;
    var query = {
      'domain': common.actual_domain,
      'row_model': 'grower',
      'rows': [{
        '_KEY': key,
        'active': active
      }]
    };

    common.method.query(common.urls.update, query).then(function () {

      var response = common.response.post_query.data;
      if (response.success) {
        //obj.loadMasterlists();

        common.updateMasterlistInventory([key], function () {});

        alertify.success('Updated.');
      } else {
        alertify.error(response.error);
      }
    });
    // }, function () {
    //   return {
    //     growers: nav.growers
    //   }
    // });
  };

  // modal.toggleMasterlist = function (grower) {
  //   console.log('emtro',grower)
  //   // obj.isLoading = true;
  //
  //     // console.log("sii",grower,obj.growerKey)
  //     obj.loadMasterlists(grower)
  //
  // };

  modal.loginAs = function (grower) {

    async.waterfall([function (cb) {
      modal.loading = true;
      common.method.run({
        key: environment.cloudscript.loginAs,
        params: { 'userType': 'grower', 'userTypeKey': grower._KEY, 'fromAdmin': true, 'user_id': grower.admin }
      }).then(function (response) {
        if (response.success) {
          cb(null, response.response.userKey);
        } else {
          modal.loading = false;
          alertify.error('Error occurred, please try again.');
          cb('Error occurred, please try again.');
        }
      }, function () {
        modal.loading = false;
        alertify.error('Error occurred, please try again.');
        cb('Error occurred, please try again.');
      });
    }, function (userKey, cb) {
      sessionSrv.validateToken(userKey, true).then(function (res) {
        if (localStorage.getItem('user_key')) {
          localStorage.removeItem('user_key');
        }
        if (res.success) {

          var state = sessionSrv.redirectUrl;
          switch (sessionSrv.user.role) {
            case 'ADMIN':
              if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'admin') {
                $state.go(state);
              } else {
                $state.go('admin.dashboard.salesmonth');
              }
              break;
            case 'GROWER':
              window.mixpanel.init(environment.mixpanel);
              window.mixpanel.identify(sessionSrv.user.id.toString());
              if (userKey) {
                localStorage.setItem('user_key', userKey);
              }

              var people = {
                $email: sessionSrv.user.email,
                $name: sessionSrv.user.name,
                role: sessionSrv.user.role
              };
              window.mixpanel.people.set(people);
              if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'grower') {
                $state.go(state);
              } else {

                var query = commonSrv.sbx.with('grower_user_config').andWhereIsEqual('user', sessionSrv.user.key).compile();

                commonSrv.method.query(commonSrv.urls.find, query).then(function (resp) {
                  var permissions = resp && resp.data && Array.isArray(resp.data.results) && resp.data.results[0] || {};

                  if (permissions.orders) {
                    $state.go('grower.orders.list');
                  } else if (permissions.claims) {
                    $state.go('grower.claims.pending.list');
                  } else if (permissions.inventory) {
                    $state.go('grower.inventory.import_assistant');
                  } else {

                    if (res && res.response && res.response.user && (res.response.user.is_admin || res.response.user.role === "GROWER")) {
                      $state.go('grower.orders.list');
                    } else {
                      $state.go(state);
                    }
                  }
                }).catch(function () {
                  $state.go(state);
                  console.log("Error loading grower permissions.");
                });
              }
              break;
            case 'COUNTRY_MANAGER':
              if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'country') {
                $state.go(state);
              } else {
                $state.go('country.purchaseorders');
              }
              break;
            default:
              sessionSrv.logout();
          }

          modal.close();
        } else {
          alertify.error(res.error);
          modal.loading = false;
          sessionSrv.logout();
        }
      });
    }], function (err, box) {
      if (err) {
        return { success: false, error: err };
      }
    });
  };

  modal.close = function () {
    $uibModalInstance.dismiss();
  };

  init();
}

function growerInfoModalCtrl($scope, commonSrv, $uibModalInstance, $filter, floristSrv, environment) {
  var modal = this,
      common = commonSrv,
      florist = floristSrv;
  var countryMap = {};
  modal.loading = false;
  modal.listMasterArr = [];
  modal.filteredList = [];
  modal.searchText = '';

  function init() {
    modal.loading = true;

    modal.loadCountries();

    var countries = [];
    if (common.getUserData().countries) {
      countries = common.getUserData().countries.map(function (it) {
        return it.country;
      });
    }

    Promise.all([commonSrv.method.run({
      key: environment.cloudscript.arrivalPerGrower,
      params: {},
      test: false
    }).then(function (res) {
      return res;
    }), commonSrv.method.run({
      key: environment.cloudscript.loadProductGroupsByGrower,
      params: {},
      test: false
    }).then(function (res) {
      return res;
    })]).then(function (data) {
      var listMasterArr = [];
      if (data[0].success) {
        listMasterArr = [].concat(_toConsumableArray(data[1].results));
        listMasterArr.forEach(function (item) {
          var days = [];
          Object.keys(data[0].info).forEach(function (key) {
            var grower = data[0].info[key].countryArrival.find(function (elem) {
              return elem._KEY === item.country;
            });

            if (grower) {
              days.push(data[0].info[key].label);
            }
          });
          item.days = days.join(', ');
        });
      }
      modal.loading = false;

      listMasterArr.forEach(function (grower) {
        grower.countryISO = getCountryFlag(grower.country);
        grower.countryFlag = grower.countryISO;
      });

      modal.listMasterArr = listMasterArr;
      modal.filterList();
      $scope.$apply();
    });
  }

  modal.close = function () {
    $uibModalInstance.dismiss();
  };

  modal.filterList = function () {
    modal.filteredList = $filter('filter')(modal.listMasterArr, function (item) {
      var name = item.name.toLowerCase().trim();
      var desc = item.desc.toLowerCase().trim();
      var days = item.days.toLowerCase().trim();
      return name.indexOf(modal.searchText.toLowerCase()) !== -1 || desc.indexOf(modal.searchText.toLowerCase()) !== -1 || days.indexOf(modal.searchText.toLowerCase()) !== -1;
    });
  };

  function getCountryFlag(country_key) {
    return getKeyByValue(environment.country, country_key);
  }

  function getKeyByValue(object, value) {
    return Object.keys(object).find(function (key) {
      return object[key] === value;
    });
  }

  modal.getImage = function (country) {
    if (country) {
      return common.actual_base_url + '/flags/' + country + '_flag.png';
    }
    return null;
  };

  modal.loadCountries = function () {
    florist.getCountriesList(function (data) {
      angular.forEach(data.results, function (item) {
        countryMap[item._KEY] = item;
      });
      modal.countries = data.results;
    }, function (err) {
      alertify.error(err);
    });
  };

  init();
}
//# sourceMappingURL=countryNavCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('countryProductCtrl', ['$scope', 'alertify', '$state', '$stateParams', 'commonSrv', 'sessionSrv', countryProductCtrl]);

  function countryProductCtrl($scope, alertify, $state, $stateParams, commonSrv, sessionSrv) {

    var obj = this,
        common = commonSrv;

    function init() {
      obj.activeTab = $stateParams.tab ? obj.tabs[$stateParams.tab] : 0;
      obj.is_manager = common.getUserData().ibf_role === 'COUNTRY_MANAGER';
    }

    obj.gotoTab = function (tab) {
      $state.go('country.products', { tab: tab });
    };

    obj.isCurrent = function (name) {
      return $state.is('country.products.' + name);
    };

    obj.include = function (name) {
      return $state.includes('country.products.' + name);
    };

    obj.tabs = {
      'product_group': 0,
      'variety': 1,
      'color': 2,
      'group_type': 3,
      'weekly_inventory': 4
    };

    init();
  }
})(angular);
//# sourceMappingURL=countryProductCtrl.js.map
